import * as React from 'react';
import { Route, Switch, withRouter } from 'react-router';
import MainHeader from 'src/components/MainHeader';
import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

import PATHS from '../../constants/paths';
import Auth from '../Auth';
import NotFound from '../NotFound';
import PagesHistory from '../PagesHistory';
import PageEditor from '../PagesHistory/PageEditor';
import { StatsContainer } from '../Stats';
import UserProfile from '../UserProfile';
import UserBadgesContainer from '../Badges';
import Footer from './Layout/Footer';
import { MobilePlaceholder } from './MobilePlaceholder';
import Toast from './Toastify';
import { useProfileSync } from './useProfileSync';

const GlobalStyle = createGlobalStyle`
  body {
    .cart-button {
      display: none;
    }
  }
`;

const RootContainer = styled.div`
  border: 1px solid ${p => p.theme.colorLightGrey};
  box-sizing: border-box;
  display: flex;
  margin: 0 auto;
  max-width: 100%;
  border-right: 0;
  border-left: 0;
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
`;

const AppContainer = styled.div`
  display: flex;
  flex-grow: 1;
  overflow: scroll;

  @media only screen and (max-width: ${p => p.theme.sizes.smallScreenWidth}) {
    padding: 0;
  }
`;

const InnerAppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  margin: 0 auto;
  max-width: 100%;
`;

const MainLayout = () => {
  return (
    <>
      <GlobalStyle />
      <MainHeader />
      <AppContainer>
        <Switch>
          <Route path={PATHS.USER_PROFILE.INDEX} exact={true} component={UserProfile} />
          <Route path={PATHS.AUTH.INDEX} component={Auth} />
          <Route path={PATHS.HOME} exact={true} component={PagesHistory} />
          <Route path={PATHS.STATISTICS.INDEX} exact={true} component={StatsContainer} />
          <Route path={PATHS.BADGES.INDEX} exact={true} component={UserBadgesContainer} />
          <Route path="*" component={NotFound} />
        </Switch>
      </AppContainer>
      <Switch>
        <Route path={PATHS.USER_PROFILE.INDEX} exact={true} component={Footer} />
        <Route path={PATHS.AUTH.INDEX} component={Footer} />
      </Switch>
    </>
  );
};

const App = () => {
  const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);

  useProfileSync();

  if (isIOSDevice) {
    return (
      <>
        <RootContainer>
          <MobilePlaceholder />
        </RootContainer>
      </>
    );
  }

  return (
    <>
      <RootContainer>
        <InnerAppContainer>
          <Switch>
            <Route path={`${PATHS.PAGES.EDIT}/:pageId`} exact={true} component={PageEditor} />
            <Route path={PATHS.PAGES.NEW} exact={true} component={PageEditor} />
            <Route path="*" component={MainLayout} />
          </Switch>
        </InnerAppContainer>
        <Toast />
      </RootContainer>
    </>
  );
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.tsx